import { Button, Card, Col, Row } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setLinkAbhaClicked, setLinkMoreDocsToAbha } from '../../../store/actions/claimDetailsAction';
import LinkRecordsModal from '../../../modules/abdmHIU/LinkDocsWithAbha/LinkRecordsModal';
import ConsentModal from '../../../modules/crm/inPatient/newAdmission/panels/ConsentModal/ConsentModal';
import { findKeyValuePair, getFileUploadStatus, getIsPageNameDetail, getIsPageNameEdit, getIsPageNameEditDischarge,
   getIsPageNameNewAdmission,
   getIsPageNameReconsider} from '../../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../../store';
import { setIsMinimize, setToggleClick, setIsModal, setShowShareDocumentOptionsModal, setShowAbhaLinkModal } from '../../../store/actions/newAdmissionAction';
import { downloadDocumentGuids } from '../../../store/actions/newAdmissionAction';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { authFeatureConstants, GUTTOR_SPACE_SMALL } from '../../constants/commonConstants';
import { getClaimHealthRecords, updateAbhaFormData } from '../../../store/actions/linkContextAction';
import { canActivate, centeredNotification } from '../../../utils/utility';
import { LinkContextModel } from '../../../store/models/linkContextModel';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';
import { fetchOtherClaimDetailMandatoryClassifications } from '../../../store/actions/lookUpAction';

const FileUploadMinimize = ({ location: { pathname }, form}: any): ReactElement => {
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const isDetailPage = getIsPageNameDetail(pathname);
  const isEditPage = getIsPageNameEdit(pathname);
  const isEditDischargePage = getIsPageNameEditDischarge(pathname);
  const isEditReconsider = getIsPageNameReconsider(pathname);

  const {
    uploadedFiles: fileList, selectedBeneficiaryDetail, isShowAdmissionForm,
    isFileUploadEnabledForce, toggleClick, downloadDocumentGuidList, showAbhaLinkModal, uploadedFiles,
    admissionFormVal, isDischargeCase, automatedProcedureOptions,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const {
    isDraftBtnClicked, nextStatusFilters,
  } = useSelector((state: RootState): any => state?.selectedInPatientDetail || {});
  const { payerLookUp, payerList:
    { payer: { uniqueIdentifier, id, showOtherBuddhimedFlow } },
  }: any = useSelector((state: RootState): RootState => state);
  const { claimDetails } = useSelector((state: RootState): any => state.admissionDetails);
  const { claimDetails: { isClaimDocLinkedToABDM, linkedToAbha, hospActionId }, linkAbhaClick, linkMoreDocsToAbha } =
    useSelector((state: RootState): any => state?.admissionDetails || {});
  const { abhaFormData } = useSelector((state: RootState): LinkContextModel => state?.linkContext || {});
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail);
  const isDocumentEnabledChecklist = appDetail?.getIsDocumentChecklistEnabled();
  const isPreAuthNewDesignEnabled = appDetail?.getIsPreAuthNewDesignEnabled();
  const isVersioningPostAPIEnabled = appDetail?.getIsVersioningPostAPIEnabled();

  const [isNew, setIsNew] = useState<boolean>(linkAbhaClick || linkMoreDocsToAbha || false);
  const [, setGlobalStatus] = useState<string>('');
  const [toggleOn, setToggleOn] = useState(false);
  const [claimHealthRecords, setClaimHealthRecords] = useState<any>({});

  const dispatch = useDispatch();

  useEffect((): void => {
    if (isClaimDocLinkedToABDM) {
      const request = {
        hospActionId,
      };
      dispatch(getClaimHealthRecords(isVersioningPostAPIEnabled ? request : hospActionId,
        onSuccessGetHealthRecords, onErrorGetHealthRecords));
    }
  }, [isClaimDocLinkedToABDM, linkMoreDocsToAbha]);

  const onSuccessGetHealthRecords = (patientContextDTO: any): void => {
    dispatch(updateAbhaFormData({ ...abhaFormData, abhaNumber: patientContextDTO?.patientAbha }));
    setClaimHealthRecords(patientContextDTO);
  };

  const onErrorGetHealthRecords = (err: any): void => {
    centeredNotification(err);
  };

  const openModal = (): void => {
    if (!isNewAdmissionPage || selectedBeneficiaryDetail || isShowAdmissionForm || isFileUploadEnabledForce) {
      dispatch(setIsMinimize(false));
      { isDraftBtnClicked && nextStatusFilters === 'DRAFT' ? dispatch(setIsModal(true)) : dispatch(setIsModal(false)); }
      fileList?.map((ele: any, index: number): any => {
        downloadDocumentGuidList?.push(ele?.docPath || ele?.response?.uploadedDetails?.map((element: any): any => {
          if (element?.fileGuid !== undefined && element?.fileGuid !== null) {
            downloadDocumentGuidList?.push(element?.fileGuid);
          }
        }));
      });
      dispatch(downloadDocumentGuids(downloadDocumentGuidList));
    }
  };

  useEffect((): void => {
    if (fileList?.length) {
      const gStatus = getFileUploadStatus<string>(fileList, ['Uploading...', 'Verifying...', 'Verified']);
      setGlobalStatus(gStatus);
    }
  }, [fileList]);
  const fileCount = fileList?.length || 0;

  useEffect((): any => {
    if (isDocumentEnabledChecklist && showOtherBuddhimedFlow && isDischargeCase) {
      const icdCode = findKeyValuePair(automatedProcedureOptions, 'id', (form?.getFieldsValue('automatedProcedure')?.automatedProcedure
        || admissionFormVal?.treatmentDetail?.automatedProcedure || claimDetails?.procedureDesc?.[0]?.payerMasterValue))?.icdCode
        || claimDetails?.icd10;

      const { masterLookId: insurerId } =
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'name', (form?.getFieldsValue('insurerName')?.insurerName ||
          admissionFormVal?.customerDetail?.insurerName || claimDetails?.insurerName)) ||
        findKeyValuePair(payerLookUp[uniqueIdentifier]?.insurerName, 'value', (form?.getFieldsValue('insurerName')?.insurerName ||
          admissionFormVal?.customerDetail?.insurerName || claimDetails?.insurerName)) ||
        {};

      const payload = {
        payerID: id,

        claimStage: isDischargeCase ? 'DischargeDocumentsSubmitted' : 'NewAdmission',

        treatment: findKeyValuePair(automatedProcedureOptions, 'id',
          (form?.getFieldsValue('automatedProcedure')?.automatedProcedure ||
            admissionFormVal?.treatmentDetail?.automatedProcedure || claimDetails?.procedureDesc?.[0]?.payerMasterValue))?.name ||
          claimDetails?.procedureDesc?.[0]?.payerMasterValue || '',

        icd: !Array.isArray(icdCode) ? [icdCode] : icdCode || [],

        insurerName: insurerId,
      };
      dispatch(fetchOtherClaimDetailMandatoryClassifications(payload));
    }
  }, [claimDetails, admissionFormVal?.customerDetail?.insurerName, admissionFormVal?.treatmentDetail?.diagnosis]);

  const onChangeSwitch = (): any => {
    if (toggleClick) {
      setToggleOn(false);
      dispatch(setToggleClick(false));
      dispatch(setShowShareDocumentOptionsModal(false));
    } else {
      setToggleOn(true);
      dispatch(setToggleClick(true));
      dispatch(setShowShareDocumentOptionsModal(true));
    }
  };

  const onLinkAbha = (): any => {
    setIsNew(true);
    dispatch(setLinkAbhaClicked(true));
  };

  const onLinkMoreDocsToAbha = (): any => {
    setIsNew(true);
    dispatch(setLinkMoreDocsToAbha(true));
  };

  const showDynamicText = uploadedFiles?.length > 0 ? 'View Documents' : 'Add Documents';
  return (
    <Card className="panel-styles maximize-card ">
      {
        isDetailPage || isEditPage || isEditDischargePage || isEditReconsider || isNewAdmissionPage ?
          <Col className="dynamictext">
            {showAbhaLinkModal && <LinkRecordsModal
              setVisible={(value: boolean): void => { dispatch(setShowAbhaLinkModal(value)); }}
              visible={showAbhaLinkModal} />}
            {
              process.env.REACT_APP_HEALTH_LOCKER_ENABLED === 'true' &&
              <div className="link-doc-text-card p-xs">
                <div className="primary-buttons-border mr-10">
                  <Button type="primary" htmlType="submit" onClick={onChangeSwitch}>
                    Link
                  </Button>
                </div>
                <p className="link-doc-text">Share Health Records with Patients</p>
              </div>

            }
            {!isPreAuthNewDesignEnabled || isDetailPage ? <a data-testid="modal-maximize-icon" className={(uploadedFiles?.length === 0
              && !isShowAdmissionForm) ? 'disabled-link link-doc-text text-underline' : 'link-doc-text text-underline'}
              onClick={openModal}>
              {showDynamicText}
            </a> : <></>}
            {isNew && <LinkRecordsModal setVisible={setIsNew} visible={isNew} isEdit={linkMoreDocsToAbha}
              selectedRecord={claimHealthRecords} />}<br/>
            {
              process.env.REACT_APP_ABHA_LINK_CLAIM_DETAILS === 'true' && canActivate(authFeatureConstants.ABDM_HIU)
              && canActivate(authFeatureConstants.EDIT_ABDM_HIU) && appDetail?.getHipId() &&
              <span>
                {isClaimDocLinkedToABDM ?
                  <Button
                    type="link"
                    className="abha-link-text"
                    disabled={uploadedFiles?.length && !isNewAdmissionPage && Object.keys(claimHealthRecords)?.length ? false : true}
                    onClick={onLinkMoreDocsToAbha}>Health Records Linked with ABHA
                  </Button>
                  :
                  linkedToAbha === 'True' ?
                    <div className="abha-link-pending-text">Link Health Records with ABHA (Pending)</div> :
                    <Button
                      type="link"
                      className="abha-link-button"
                      disabled={uploadedFiles?.length && !isNewAdmissionPage ? false : true}
                      onClick={onLinkAbha}>Link Health Records with ABHA
                    </Button>
                }
              </span>
            }
          </Col>
          : <Row gutter={GUTTOR_SPACE_SMALL} align="middle">
            <Col md={8}>
              <p className="label-value mb-0 fsize_sm">{fileCount} Documents</p>
            </Col>
            {/* <Col md={3}>
              {
                percent && fileCount > 0 ? <Progress type="circle" percent={percent} width={20} /> : null
              }
            </Col>
            <Col md={10}>
              <p className="text-primary bold mb-0 fsize_sm text-right">
                {
                  (globalStatus)
                }
              </p>
            </Col>
            <Col md={3} className="text-right">
              {!isNewAdmissionPage || (isNewAdmissionPage &&
                 (!isEmpty(selectedBeneficiaryDetail) || isManualSubmission)) ? <Tooltip title="View document">
                <MaximizeIcon data-testid="modal-maximize-icon" className="maximize-icon" onClick={openModal} />
              </Tooltip> : null}
            </Col> */}
          </Row>
      }
      {toggleClick && toggleOn &&
        <ConsentModal />
      }
    </Card>
  );
};

export default withRouter(FileUploadMinimize);
